module.exports = __webpack_public_path__ + "img/closed_light.01da78e4.svg";